import { oc } from '@orpc/contract';
import { idParamSchema } from '../../common/schemas/id.schemas.js';
import { scenarioSchema } from '../schemas/scenarios.schemas.js';
export const getScenarioContract = oc
    .route({
    method: 'GET',
    path: '/scenarios/{id}',
    tags: ['Scenarios'],
    summary: 'Read one test scenario',
})
    .input(idParamSchema)
    .output(scenarioSchema);
//# sourceMappingURL=get-scenario.contract.js.map